import { z } from "zod";
import {
  EGovernmentPhotoIDType,
  EWorkerVerificationIDType,
  worker_types,
} from "@zeal/common";

export type TSubmitPersonaVerificationResponse = {
  governmentPhotoIDType: EGovernmentPhotoIDType;
  workerVerificationIDType: EWorkerVerificationIDType;
};

export const submitPersonaVerificationSchema = z.object({
  workerType: z.nativeEnum(worker_types),
  personaInquiryId: z.string(),
});

export type TSubmitPersonaVerification = z.infer<
  typeof submitPersonaVerificationSchema
>;
